import { Link as RouteLink } from '@root/vendor/react-router-dom';

export default RouteLink;
